import * as Sentry from "@sentry/core";

namespace Telemetry {
  export declare namespace captureError {
    type Options = {
      level?: Sentry.SeverityLevel;
      tags?: Record<string, string | number | boolean | undefined>;
      extra?: Record<string, unknown>;
    };
  }
  export function captureError(
    error: Error,
    options: captureError.Options = {}
  ) {
    Sentry.captureException(error, {
      ...options,
      tags: { bypassSuppression: true, ...(options.tags ?? {}) },
    });
  }
  export function withScope<R>(
    fn: (
      scope: Pick<Sentry.Scope, "setTags" | "setExtras" | "setTag" | "setExtra">
    ) => R
  ): R {
    return Sentry.withScope(fn);
  }
}

export default Telemetry;
